import React from 'react';

import { twMerge } from 'tailwind-merge';

import { AppStoreButtons } from '../../../../components/Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Text } from '../../../../components/Text/Text';
import { useUserInfo } from '../../../../helpers/hooks/useUserInfo';

interface IProps {
  biography: string | null;
  anglerId: string;
  className: string;
}

export const AnglerBio = ({ biography, anglerId, className }: IProps) => {
  const { user } = useUserInfo();

  return (
    <div>
      {biography && biography.length ? (
        <Text
          variant="md"
          className={twMerge(
            `mb-0 px-4 pt-0 pb-4 md:px-0 md:pt-4 ${
              biography && biography.length ? '' : 'text-midnight italic'
            }`,
            className,
          )}
        >
          {biography}
        </Text>
      ) : (
        <>
          {user && user._id === anglerId && (
            <div className="text-midnight mb-6 flex flex-col items-center">
              <Text className="italic">
                You currently don&apos;t have a bio set. You can create a bio in the Fishbrain app.
              </Text>
              <AppStoreButtons source="AnglerBio" />
            </div>
          )}
        </>
      )}
    </div>
  );
};
